<template>
  <div
    v-if="props.currentState === 'success'"
    class="text-static-success-hi flex items-center gap-12"
  >
    <component :is="iconMapping[type][currentState]" size="medium" />
    <div class="flex flex-col gap-2">
      <RevTag
        class="w-fit"
        :label="tagContent"
        size="small"
        variant="success"
        variation="filled"
      />
      <p v-if="formattedPrice" class="body-1-bold">{{ formattedPrice }}</p>
      <p v-if="additionalInfo" class="caption-bold">{{ additionalInfo }}</p>
    </div>
  </div>

  <div
    v-else-if="props.currentState === 'pending'"
    class="text-static-info-hi flex w-full max-w-[400px] items-center gap-12"
  >
    <component :is="iconMapping[type][currentState]" size="medium" />
    <div class="flex flex-col gap-2">
      <RevTag
        class="!bg-static-default-hi w-fit"
        :label="tagContent"
        size="small"
        variant="secondary"
        variation="filled"
      />
      <p class="text-static-default-hi body-1-bold">{{ formattedPrice }}</p>
      <p v-if="additionalInfo" class="caption-bold">{{ additionalInfo }}</p>
    </div>
  </div>

  <div
    v-else
    class="text-static-info-hi flex w-full max-w-[400px] items-center gap-12"
  >
    <component :is="iconMapping[type][currentState]" size="medium" />
    <div class="flex flex-col gap-2">
      <RevTag
        class="!bg-static-default-hi w-fit"
        :label="tagContent"
        size="small"
        variant="secondary"
        variation="filled"
      />
      <p class="text-static-default-hi body-1-bold">{{ formattedPrice }}</p>
      <p v-if="additionalInfo" class="caption-bold">{{ additionalInfo }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevTag } from '@ds/components/Tag'
import { IconAlertFilled } from '@ds/icons/IconAlertFilled'
import { IconBoltFilled } from '@ds/icons/IconBoltFilled'
import { IconCheckInCircleFilled } from '@ds/icons/IconCheckInCircleFilled'
import { IconDealFilled } from '@ds/icons/IconDealFilled'
import { IconFireFilled } from '@ds/icons/IconFireFilled'

const props = defineProps<{
  /** The formatted price string to display (e.g., "€299.99")
   *  This value can be optional but only when the market is using the sales maximizer price strategy
   */
  formattedPrice?: string
  currentState: 'default' | 'pending' | 'success'
  additionalInfo?: string
  type: 'backbox' | 'salesMaximizerPrice' | 'deal'
  tagContent: string
}>()

const iconMapping = {
  backbox: {
    success: IconCheckInCircleFilled,
    pending: IconAlertFilled,
    default: IconFireFilled,
  },
  salesMaximizerPrice: {
    success: IconBoltFilled,
    pending: IconAlertFilled,
    default: IconBoltFilled,
  },
  deal: {
    success: IconDealFilled,
    pending: IconDealFilled,
    default: IconAlertFilled,
  },
} as const
</script>
